import React, { useRef } from 'react';
import { Card } from 'react-bootstrap';
import { usePaginatedQueryV8 } from 'motion-components';

import { useTranslation } from 'react-i18next';

// import { usePaginatedQueryV8 } from 'motion-components';
import { useLocation } from 'react-router-dom';
import { useRootStore } from 'store';
import { getCollectionLinesSums, gqlGetQuery } from './graphql';
import { GridPage } from './grid';
import { useHandleError } from 'shared-pages/services';

import { orderBy } from 'lodash';
import { buildWhereFromFilterValues, Filters } from './filters';
import { useLazyQuery } from '@apollo/client';

//import { usePaginatedQueryV8 } from '../../../../motion-components/src/lib/common/tables/table-v8/paginated-query-v8';

/* ────────────────────────────────────────────────────────────── */
/* Main Page component                                           */
/* ────────────────────────────────────────────────────────────── */
const CollectionPointReportPage: React.FC = () => {
  const { t } = useTranslation();
  const gridRef = useRef();

  const { appStore, tableStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('CollectionPointReportPage');
  const location = useLocation<any>();
  /* Paginated grid data */

  const [getSumsData, { data: sumDataRaw }] = useLazyQuery(getCollectionLinesSums, {
    fetchPolicy: 'network-only',
  });
  const sumData = sumDataRaw?.getCollectionLinesSums;
  const onQueryCompleted = async (queryParams, data) => {
    // get Sums per Material
    const initialWhereStr = queryParams.where;
    if (initialWhereStr) {
      const sumWhereStr = initialWhereStr
        .replaceAll('isActive', '$collection.isActive$')
        .replaceAll('collectionPointId', '$collection.collectionPointId$')
        .replaceAll('dateCollected', '$collection.dateCollected$');
      await getSumsData({ variables: { where: sumWhereStr } });
    }
  };

  const initOrderBy = 'dateCollected DESC';
  const query = usePaginatedQueryV8(
    gqlGetQuery,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    true, /// execute On Mount
    { isActive: true, collectionPointId: -1 }, // Default filters
    false, // History Replace   //Keep state in history to persist filters  $$$$ δεν δουλεύει το Dialog FieldCollectionPointDlg όταν true
    'collection_point_report_grid', //key name when nesting in location.state
    true, // always on filter
    onQueryCompleted,
  );
  const {
    loading,
    data,
    dataCount,
    error,
    initPageIndex,
    filtersChanged,
    gridPageChanged,
    queryState,
    queryParams,
    setQueryParams,
    refetch,
  } = query;

  /* ------------------------------------------------------------------- */

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  }

  return (
    <Card className="shadow">
      <Card.Header>
        <h4> {t('Αναλυτική Αναφορά Συλλογών ενός Σημείου Συλλογής')} </h4>
      </Card.Header>

      {/* ───────── Filters Row ───────── */}
      <Card.Body>
        <Filters
          onChange={filtersChanged}
          initialValues={queryState?.filters}
          disable={false}
          isGridInForm={false}
        />

        {/* ───────── Grid ───────── */}
        {data && sumData && (
          <div className="mt-4">
            <GridPage
              ref={gridRef}
              loading={loading}
              data={data}
              sumData={sumData}
              dataCount={dataCount}
              initPageIndex={initPageIndex}
              onPageChange={gridPageChanged}
              initOrderBy={queryParams?.order ?? orderBy}
              onOrderChange={(orderNew) => setQueryParams({ ...queryParams, order: orderNew })}
              isGridInForm
              isModal
              refetch={refetch}
            />
          </div>
        )}
        {!data && (
          <div className="text-center mt-4">
            <h3>{t('Δεν υπάρχουν δεδομένα για εμφάνιση')}</h3>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default CollectionPointReportPage;

